<template>
    <div>
        <div class="pg-loading" v-if="show">
            <img src="./image/pg-loading.gif" class="loading-img" alt="" draggable="false">
            <span class="loading-text">{{text}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        props: {
            show: Boolean,
            text: {
                type: String,
                default: 'loading'
            }
        }
    }
</script>

<style lang="scss">
    .pg-loading {
        padding: 30px 0;
        text-align: center;

        .loading-img {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-right: 8px;
        }

        .loading-text {
            display: inline-block;
            vertical-align: middle;
            font-size: 13px;
            color: #999;
        }
    }
</style>
